import { render, staticRenderFns } from "./LineResultsProduct.vue?vue&type=template&id=2848c097&"
import script from "./LineResultsProduct.vue?vue&type=script&lang=js&"
export * from "./LineResultsProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports